<template>
  <div class="RB_nav">
    <div class="inner con">
      <div class="logo">
        <img src="/statics/images/index/logo.png" alt />
      </div>
      <ul>
        <li @click="toPath('/',{})">集团首页</li>
        <li @click="toPath('/jt_survey',{})">集团概况</li>
        <li @click="toPath('/product_zx',{})">产品中心</li>
        <!-- <li @click="toPath('/achievement_gk',{})">业绩概况</li> -->
        <!-- <li @click="toPath('/news_zx',{})">新闻资讯</li> -->
        <li @click="toPath('/service_zc',{})">服务支持</li>
        <li @click="toPath('/contact_us',{})">联系我们</li>
        <!-- <li @click="toPath('/download_zx',{})">下载中心</li> -->
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    toPath(url, obj) {
      if (this.$route.fullPath == url) {
          window.location.reload()
      } else {
        this.$router.push({
          path: url,
          query: obj
        });
      }
    }
  }
};
</script>

<style>
</style>